module.exports = __webpack_public_path__ + "static/media/fcc-desktop.10d235e8.png";